// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App-container {\n  max-width: 960px;\n  padding: var(--m) var(--m);\n  margin: auto;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd","sourcesContent":[".App-container {\n  max-width: 960px;\n  padding: var(--m) var(--m);\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
